import * as styles from "./metricIconBadge.module.scss";

export const MetricIconBadge = ({ icon, color, bgColor }) => (
  <span
    className={styles.metricIconBadge}
    style={{ color, backgroundColor: bgColor }}
  >
    {icon}
  </span>
);
